import { useTranslation } from "react-i18next";
import Paragraph, { ParagraphSize } from "../../../components/Paragraph";
import AssetsPack from "../../../util/AssetsPack";
import style from "./DownloadTagComponent.module.css";
import { ApkLink } from "../../../util/Constant";
import { ButtonType, JokerButton } from "material-ui-jokerpro";

const DownloadTagComponent = () => {
  const { t } = useTranslation();

  const onClickDownloadApk = () => {
    window.location.href = ApkLink;
  };

  return (
    <div className={style["main-container"]}>
      <div className={style["tag-container"]}>
        <div className={style["tag-info-container"]}>
          <Paragraph
            size={ParagraphSize.paragraph1}
            classNameStyle={style["text-colors"]}
          >
            {t(
              "joker_download_page.download_latest_apk_tag.download_latest_apk"
            )}
          </Paragraph>
          <Paragraph
            size={ParagraphSize.paragraph2}
            classNameStyle={style["text-margin"]}
          >
            {t("joker_download_page.download_latest_apk_tag.description")}
          </Paragraph>

          <Paragraph
            size={ParagraphSize.paragraph2}
            classNameStyle={style["text-Highlight"]}
          >
            {t(
              "joker_download_page.download_latest_apk_tag.description_underline"
            )}
          </Paragraph>
        </div>

        <div
          className={style["download-view-container"]}
          onClick={onClickDownloadApk}
        >
          <JokerButton
            text={t("global_component.download_now")}
            onClick={onClickDownloadApk}
            type={ButtonType.CTA}
            icon={`${AssetsPack.icons.ICON_DOWNLOAD_GOLD.default}`}
            style={{ backgroundColor: "#262626" }}
          />
        </div>
      </div>
    </div>
  );
};

export default DownloadTagComponent;
